import {Button, Card, Col, FormControl, FormGroup, Row} from 'react-bootstrap';

const UsersSearch = (props) => {
  const doSearch = (e) => {
    if (e.key === 'Enter') {
      props.onSearch();
    }
  };

  return (
    <Card className="user-filter admin-search-filter">
      <Card.Body>
        <Row>
          <Col md={12}>
            <FormGroup>
              <FormControl
                onChange={props.onInputChange}
                onKeyPress={doSearch}
                placeholder="Search by user id, first name, last name, username..."
                value={props.searchValue}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <FormGroup>
              <FormControl
                as="select"
                onChange={props.onUserGroupFilterChange}
                value={props.userGroupFilterValue}
              >
                <option value="">
                  [Usergroup]
                </option>
                {
                props.userGroups && props.userGroups.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))
              }
              </FormControl>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <FormControl
                as="select"
                onChange={props.onStatusFilterChange}
                value={props.statusFilterValue}
              >
                <option value="">
                  [Status]
                </option>
                {
                props.statuses && Object.keys(props.statuses)
                  .map(key => (
                    <option key={key} value={key}>
                      {props.statuses[key]}
                    </option>
                  ))
              }
              </FormControl>
            </FormGroup>
          </Col>
          <Col className="actions" md={4}>
            <Button
              className="red-ghost-btn"
              onClick={props.onSearch}
            >
              Search
            </Button>

            <Button
              className="red-ghost-btn"
              onClick={props.onClear}
            >
              Clear search
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default UsersSearch;
